export default "__VITE_ASSET__D78NgiOq__"